import React from 'react';
import GameCardForm from './gamesFrom.jsx';
import common from '../../common.module.scss';

export default function CreateGamePage() {
    return (
        <main className={common.container + " min-vh-100 d-flex justify-content-center align-items-center"}>
            <GameCardForm />
        </main>
    );
}
